var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.columns),function(item){return _c('van-button',{key:item.value,attrs:{"type":_vm.selectedValue === item.value ? 'info' : 'default'},on:{"click":function($event){return _vm.handleClick(item.value)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }